'use strict';
var _ = require('lodash');
var Backbone = require('backbone');
var template = require('../../templates/modal.ejs');
var constants = require('../../constants/keyboard');
var PubSub = require('tscom-pubsub');

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-modal',
    /**
     * Initialize Modal View
     */
    initialize: function (options) {
        _.bindAll(this, 'render');

        // The element to focus on when the modal is closed
        this.finalFocusRef = options.finalFocusRef;
        this.keyDownEvent = this.handleKeyDown.bind(this);
        window.addEventListener('keydown', this.keyDownEvent);
    },
    /**
     * Render Modal View
     */
    render: function () {
        this.$el.html(template());
        this.$('.modal-content').append((_.isObject(this.model.view) ? this.model.view.render().$el : this.model.view));
        return this;
    },

    trapFocus: function() {
        var focusable = this.el.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), button:not([disabled]), [tabindex="0"]');
        this.focusableEls = Array.prototype.slice.call(focusable);
        this.firstFocusableEl = this.focusableEls[0];
        this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];

        if (this.$el.find('[data-focusable]').length > 0) {
            this.$el.find('[data-focusable]')[0].focus();
        } else {
            this.el.getElementsByClassName('close')[0].focus();
        }

    },

    handleKeyDown: function(e) {
        switch (e.keyCode) {

        case constants.ESCAPE:
            PubSub.trigger('closeModal');
            break;

        case constants.TAB:
            if (this.focusableEls.length === 1) {
                break;
            }

            if (e.shiftKey) {
                if (document.activeElement === this.firstFocusableEl) {
                    e.preventDefault();
                    this.lastFocusableEl.focus();
                }
            } else {
                if (document.activeElement === this.lastFocusableEl) {
                    e.preventDefault();
                    this.firstFocusableEl.focus();
                }
            }

            break;

        default:
            break;
        }
    },

    remove: function() {
        window.removeEventListener('keydown', this.keyDownEvent);
        Backbone.View.prototype.remove.call(this);
    }
});



// WEBPACK FOOTER //
// ./app/scripts/common/views/modal.js